module.exports = __webpack_public_path__ + "img/atosaca.bf934836.png";